import templateUrl from './pay-stub-totals-summary.component.html'

export const PayStubTotalsSummaryComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        payStubEntry: "<"
    }
}
